module.exports = __webpack_public_path__ + "static/media/Introducing Reopen a Closed RFI for BIM 360 Project Management.f7b814f6.png";